/** Generated from the LifeMindsAI field catalog. Do not edit. */

export const CATALOG_RENDERER_NAMES = {
  DAILYMED_LINK: 'dailymed_link',
  IME_SERIOUSNESS: 'ime_seriousness',
  MEDDRA_CODING: 'meddra_coding',
} as const;

export type CatalogRendererName =
  (typeof CATALOG_RENDERER_NAMES)[keyof typeof CATALOG_RENDERER_NAMES];
